import * as React from "react";
import {Modal} from "semantic-ui-react";
import {FC} from "react";
import Dropdown from "semantic-ui-react/dist/commonjs/modules/Dropdown";

type AboutModalProps = {
    open: boolean;
    setShowMissingLanguageModal(newValue: boolean): void;
}

export const MissingLanguageModal: FC<AboutModalProps> = ({setShowMissingLanguageModal, open = false}) =>  {
    return (
        <Modal open={open}
               trigger={<Dropdown.Item>Audio Problems</Dropdown.Item>}
               onOpen={(e) => {
                   console.log("setting modal open to true")
                   setShowMissingLanguageModal(true);
               }}
               onClose={(e) => {
                   console.log("setting modal open to false")
                   setShowMissingLanguageModal(false);
               }}
        >
            <Modal.Header>Problems playing pronunciation sounds</Modal.Header>
            <Modal.Content>
                <p>Pronunciations not being played typically ahppens when your browser or operating system is missing Japanese language support.</p>
                <p>This commonly happens on Windows. You might want to install support following <a href={"https://support.microsoft.com/en-us/office/how-to-download-text-to-speech-languages-for-windows-10-d5a6b612-b3ae-423f-afa5-4f6caf1ec5d3"} target={"_blank"}>this guide.</a></p>
                <p>Another option is to use Google Chrome which seems to ship with support for Japanese built in. However, if you are serious about learning Japanese, you might want to install support for Japanese on your OS anyways.</p>
                <p>If the issue persists, please let us know via our <a href={"https://forms.gle/dUvvhRJzHxdEBEHj7"} target={"_blank"}>feedback form</a></p>
            </Modal.Content>
        </Modal>
    )
}


// WEBPACK FOOTER //
// ./src/components/MissingLanguageModal.tsx